import { render, staticRenderFns } from "./CompleteRegistration.vue?vue&type=template&id=3f635463&"
import script from "./CompleteRegistration.vue?vue&type=script&lang=ts&"
export * from "./CompleteRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports